import axiosService from '../axios'

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.todo/${id}`,
    method: 'put',
    data,
  })
}

export const complete = (id: number) => {
  return axiosService({
    url: `/api.todo/${id}/complete`,
    method: 'put',
  })
}

export const unComplete = (id: number) => {
  return axiosService({
    url: `/api.todo/${id}/un-complete`,
    method: 'put',
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.todo/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.todo',
    method: 'post',
    data,
  })
}
